import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'found';
import MobileSidebar from 'react-sidebar';
import Sidebar from './SidebarComponent';
import Header from './HeaderComponent';
import styles from './App.scss';
import styleVariables from '../variables';
import globalStyles from '../globals.scss';
import { commitMutation, graphql } from 'react-relay';
import moment from 'moment';

const AppContext = React.createContext({
  window: { width: window.innerWidth, height: window.innerHeight }
});

export const AppConsumer = AppContext.Consumer;

const AppComponent = class App extends React.Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = { sidebarOpen: false };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillMount() {
    this.updateWindowDimensions();
    const { viewer } = this.props;
    if (viewer && !viewer.s_time_zone) this.setTimeZone();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  setTimeZone() {
    const onError = (e) => {
      // eslint-disable-next-line
      console.error('Error updating user time zone', e);
    };

    const mutation = graphql`
      mutation AppComponent_updateUserMutation(
        $input: UpdateUserInput!
      ) {
        updateUser(input: $input) {
          user {
            s_time_zone
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id: this.props.viewer.id,
          s_time_zone: moment.tz.guess()
        }
      },
      onError
    });
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  toggleSidebar(ev) {
    ev.preventDefault();
    this.onSetSidebarOpen(!this.state.sidebarOpen);
  }

  updateWindowDimensions() {
    this.setState({
      window: { width: window.innerWidth, height: window.innerHeight },
      isMobile: window.innerWidth < styleVariables.tabletBreakpoint,
      isComputer: window.innerWidth >= styleVariables.tabletBreakpoint,
      isLargeScreen: window.innerWidth >= styleVariables.largeScreenBreakpoint
    });
  }

  render() {
    return (
      <div className={styles.root}>
        <AppContext.Provider value={this.state}>
          <MobileSidebar
            sidebar={
              <Sidebar
                setSidebarOpenState={this.onSetSidebarOpen}
                router={this.props.router}
                viewer={this.props.viewer}
              />
            }
            sidebarClassName={styles.mobileSidebar}
            open={this.state.sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
            touch={false}
          >
            <Header viewer={this.props.viewer} router={this.props.router} />
            {React.cloneElement(this.props.children, {
              toggleSidebar: this.toggleSidebar,
              sidebarOpen: this.state.sidebarOpen
            })}
            <div id='desktopModal' className={globalStyles.desktop} />
            <div id='mobileModal' className={globalStyles.mobile} />
          </MobileSidebar>
        </AppContext.Provider>
      </div>
    );
  }
};

export default withRouter(AppComponent);



// WEBPACK FOOTER //
// ./webpack/components/App/AppComponent.js